import * as constant from "../Constants";
import { BaseService } from "../Base";

export class Service extends BaseService {
  constructor(modulePath) {
    super();
    this.configuration = {
      ...this.configuration,
      method: constant.BASE.method.post,
      resource: modulePath
    };
    this.query = null;
  }
}
